import(/* webpackMode: "eager" */ "/workspace/impact-ot/src/app/error.tsx");
